export default __webpack_public_path__ + "static/media/thumbnail.b1be69c9.png";